import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { githubSyncDialogChangesPushed } from './github-sync-dialog.actions';

@Injectable({
  providedIn: 'root',
})
export class GithubSyncDialogFacade {
  static Actions = { githubSyncDialogChangesPushed };

  constructor(private readonly store: Store) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
